import {useInfiniteQuery} from '@tanstack/react-query'
import api from 'src/services/api'
import {QueryKeyEnum} from 'src/utilities/enums/QueryKeyEnum'

type Props = {
  search?: {
    clientName?: string
    id?: number
    macAddress?: string
  }
  filter?: {
    companyIds: Array<number>
  }
}

export default function useEdgeServers({search, filter}: Props) {
  const query = useInfiniteQuery({
    retry: 0,
    initialPageParam: 0,
    queryKey: [QueryKeyEnum.EDGE_SERVERS, search, filter],
    queryFn: async ({pageParam: nextPage}) => {
      if (nextPage === -1) throw new Error('No more page to load')

      const response = await api.company.getEdgeServers({
        pageSize: 20,
        page: nextPage,
        search,
        filter,
      })

      return response.data.data
    },
    getNextPageParam: (lastPage) => {
      const current = lastPage.currentPage
      if (lastPage.entities.length < 20) return undefined
      return current + 1
    },
    throwOnError: () => {
      throw new Error('No more page to load')
    },
  })

  return query
}
